export default __webpack_public_path__ + "static/media/sounds/clpl_practice_option_two_Alyx.mp3";